'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
const $ = require("jquery");
class Scroll {
    constructor() {
        const self = this;
        $('a[href^="#"], a[href*="/#"]').click(function () {
            const href = $(this).attr("href");
            if (self.isAnchor(href)) {
                self.scrollToAnchor(href);
                return false;
            }
        });
        // URLがアンカーリンク付きだった時
        // window.addEventListener('load', () => {
        $(window).on('load', () => {
            const url = location.href;
            if (this.isAnchor(url)) {
                $("html, body").animate({ scrollTop: 0 }, 0, 'linear');
                setTimeout(() => {
                    self.scrollToAnchor(url);
                }, 300);
                return false;
            }
        });
    }
    isAnchor(href) {
        return href.indexOf('#') != -1;
    }
    getAnchorName(href) {
        const index = href.indexOf('#');
        return href.slice(index + 1);
    }
    scrollToAnchor(href) {
        let headerHeight = $('.paramHeader').outerHeight() | 0;
        const anchor = this.getAnchorName(href);
        const position = $('#' + anchor).offset().top - headerHeight;
        $("html, body").animate({ scrollTop: position }, 400, 'linear');
    }
}
exports.Scroll = Scroll;
exports.default = Scroll;
